import { useLocation, useMeasure } from 'react-use';

import { HeadingsInfo } from '../../../config';
import { Heading } from '../../../GlobalComponents/Heading';
import { ToolBar } from '../ToolBar';

const attachedStyles: React.CSSProperties = {
	position: 'fixed',
	zIndex: 999,
	top: 0,
	left: 0,
	right: 0,
	backgroundColor: '#F5F2F2'
};

export const MobileHeader: React.FC = () => {
	const [ref, { height }] = useMeasure<HTMLDivElement>();
	const location = useLocation();
	const pathname = location.pathname || '';

	const getTitleByPath = (pathName: string) => {
		const path = pathName.split('/').pop();
		const matchingHeadingConfig = HeadingsInfo.find(
			heading => heading.path === path
		);
		return matchingHeadingConfig ? matchingHeadingConfig : HeadingsInfo[0];
	};

	const headingDetails = getTitleByPath(pathname);

	return (
		<>
			<div style={{ height: height }} />
			<div className="w-100 header" id="mobile-header">
				<div style={attachedStyles} ref={ref}>
					<ToolBar />
					{pathname !== '/checkout/payment' && (
						<Heading
							title={headingDetails.title}
							showBottomBorder={headingDetails.showBottomBorder}
						/>
					)}
				</div>
			</div>
		</>
	);
};
